import Rollbar from "rollbar";

export function initRollbar(env: any, accessToken: any) {
  window.Rollbar = Rollbar.init({
    accessToken,
    captureUncaught: true,
    captureUnhandledRejections: true,
    payload: {
      environment: env,
      source_map_enabled: true,
    },
  });
}